export function isIE() {
  const ua = window.navigator.userAgent
  return /MSIE|Trident/.test(ua)
}